export const FooterContent = () => (
  <div className="w-fit text-gray-medium font-aeonik font-light text-[0.875rem]/[1.25rem]">
    &copy; {new Date().getFullYear()} SPYSCAPE. All rights reserved.
  </div>
);
